<label class="subHeading">{{label}} <span class="astrik" *ngIf="required">*</span></label>
<app-autocomplete-field
    [controlName]="controlName"
    [config]="autoCompleteFieldOptions"
>
</app-autocomplete-field>